import tw from 'twin.macro';

const Anchor = tw.a`text-purple-800 font-semibold rounded px-1 -mx-1 hover:bg-yellow-300`;

export default Anchor;
